import script from "./NoticiaDetalle.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaDetalle.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaDetalle.vue?vue&type=style&index=0&id=453ac650&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453ac650"]])

export default __exports__